import { Injectable } from "@angular/core";
import { RelevantFileGroup, getRelevantFilePath } from '../interface/relevant-file';
import { RELEVANT_FILE } from "../config/relevant-file.config";

@Injectable()
export class RelevantFileService {

  /**
   * 获取该文件的关联文件配置
   * @param path 文件路径
   * @returns 关联文件配置
   */
  private getRelevantFileGroup(path: string): RelevantFileGroup {
    if (!path) {
      return null;
    }
    // 从上至下依次遍历关联文件配置，如果存在与本文件相同的后缀，则找到关联文件组
    for (const fileGroup of RELEVANT_FILE) {
      const suffixes = fileGroup.suffixes;
      for (const suffix of suffixes) {
        if ( path.endsWith(suffix) ) {
          if ( !fileGroup.getRelevantFilePath ) {
            fileGroup.getRelevantFilePath = getRelevantFilePath;
          }
          return fileGroup;
        }
      }
    }
    return null;
  }

  /**
   * 获取该文件的关联文件的路径集合（返回值包含入参）
   * @param path 文件路径
   * @returns 关联文件路径集合
   */
  public getRelevantFilePaths(path: string): string[] {
    const groupConfig = this.getRelevantFileGroup(path);
    if (!groupConfig) {
      return [ path ];
    }
    const relPaths = [];
    for (const suffix of groupConfig.suffixes) {
      if ( !path.endsWith(suffix) ) {
        relPaths.push(
          groupConfig.getRelevantFilePath(path, suffix)
        );
      } else {
        relPaths.push( path );
      }
    }
    return relPaths;
  }

}
